"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.originals = void 0;
var _nreum = require("../../window/nreum");
const originals = exports.originals = (0, _nreum.gosNREUMOriginals)().o;